/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Err_WhenInputs */

const en_messages_err_when = /** @type {(inputs: Messages_Err_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick when to send it.`)
};

const he_messages_err_when = /** @type {(inputs: Messages_Err_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחר מתי לשלוח.`)
};

/**
* | output |
* | --- |
* | "Pick when to send it." |
*
* @param {Messages_Err_WhenInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_err_when = /** @type {((inputs?: Messages_Err_WhenInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Err_WhenInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_err_when(inputs)
	return he_messages_err_when(inputs)
});